export const CONSTRUCTION_PRESET = {
    label: 'Construction',
    keys: {
        project: 'Project',
        projects: 'Projects',
        existingProject: 'Project',
        existingProjects: 'Projects',
        potentialProject: 'Opportunity',
        potentialProjects: 'Opportunities',
        serviceLine: 'Market Sector',
        serviceLines: 'Market Sectors',
        projectTypeGroup: 'Building Category',
        projectType: 'Project Type',
        projectTypes: 'Project Types',
        revenue: 'Revenue',
        revenueAtRisk: 'Revenue at Risk',
        t12Revenue: '12-Month Revenue',
        tXRevenue: '#{month}-Month Revenue',
        revenueTD: 'Revenue TD',
        averageRevenue: 'Average Revenue',
        averageRevenueSize: 'Average Contract Size',
        firmGrowthPotential: 'Firm BD Potential',
        growthPotential: 'BD Potential',
        parentCrm: 'Account Manager',
        parentCrms: 'Account Managers',
        parentCustomerRelationsManager: 'Account Manager',
        parentCustomerRelationsManagers: 'Account Managers',
        subCrm: 'Project Executive',
        subCrms: 'Project Executives',
        subCustomerRelationsManager: 'Project Executive',
        subCustomerRelationsManagers: 'Project Executives',
        hoursBilled: 'Labor Hours',
        allFirm: 'Company-wide',
        myProjects: 'My Projects',
        projectPIC: 'Project Lead',
        projectPersonInCharge: 'Project Lead',
        cm: 'AM',
        projectCRMs: 'Project Account Managers',
    },
    tooltipReplacements: [
        { from: 'Matter', to: 'Project' },
        { from: 'matters', to: 'projects' },
        { from: 'Billings', to: 'Revenue' },
        { from: 'billings', to: 'revenue' },
        { from: 'Practice Area', to: 'Market Sector' },
        { from: 'Practice Areas', to: 'Market Sectors' },
        { from: 'Billing Partner', to: 'Project Executive' },
    ],
};
